/**
 * Shared brand palette for the Motosport Software marketing site.
 *
 * These mirror the CSS custom properties in `src/styles.css`. Keep this file
 * as the single source of truth for the hex values used in inline `style`
 * props and JS color logic, so the constants stop drifting between files.
 */
export const theme = {
  bg: "#F7F7F5",
  bgAlt: "#FAF8F3",
  dark: "#1F2A3A",
  darkCard: "#2A3547",
  darkBorder: "#3A4658",
  heading: "#1F2A3A",
  mutedText: "#525A68",
  red: "#BC0319",
  redLight: "#DD7A5E",
  accentBg: "#FCE8E4",
  border: "#EDEBE4",
  lightAccent: "#f84646ff",
} as const;
